module.exports = __webpack_public_path__ + "img/avatar-9.c11b6f38.jpg";